import { LitElement } from '~/lib/bn-lit-element';
import { css } from '../../utility/lit-entity';
import { DeviceMonitoringChartLayerLineMixin } from './device-monitoring-chart-layer-line-mixin';

const THRESHOLDS = { warning: -80, alert: -100 };

export const colour = css`var(--indigo-50)`;
export const isValid = (event) => typeof event.cellStrength === 'number';
export const hasWarning = (event) => isValid(event) && event.cellStrength < THRESHOLDS.warning;
export const hasAlert = (event) => isValid(event) && event.cellStrength < THRESHOLDS.alert;

class DeviceMonitoringChartLayerCell extends DeviceMonitoringChartLayerLineMixin(LitElement) {
  constructor() {
    super();
    this.dataKey = 'cellStrength';
    this.maxValue = -40;
    this.minValue = -113;
    this.warningValue = THRESHOLDS.warning;
    this.alertValue = THRESHOLDS.alert;
  }

  static get styles() {
    return [...super.styles, css`
      :host {
        --good-stroke: ${colour};
        --warning-stroke: var(--indigo-50);
        --alert-stroke: var(--indigo-60);
      }
    `];
  }

  parseData(events) {
    return super
      .parseData(events)
      .filter((point) => isValid(point.event));
  }
}

window.customElements.define('device-monitoring-chart-layer-cell', DeviceMonitoringChartLayerCell);
